import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { ConfirmModal } from "ceco-modal";
import graphql from "babel-plugin-relay/macro";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";

export default function UnitsDeleteModal(props) {
  const { trigger, unitName, unitId, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState();
  const t = useTranslation();

  function deleteCategory() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
      };
      commitMutation(environment, {
        mutation: UnitsDeleteModalMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    deleteCategory()
      .then((a) => {
        toast.success(t("message.deleted_unit"));
        setModalOpen(false);
        refetchData();
      })
      .catch((e) => {
        if (Array.isArray(e)) {
          toast.error(e[0].message);
        } else {
          toast.error(e.errors[0].message);
        }
      });
  };
  return (
    <ConfirmModal
      modalOpen={modalOpen}
      title={t("modalTitle.removeUnits")}
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          setFormData({ id: unitId });
        },
      })}
      onClose={() => setModalOpen(false)}
      showCloseButton={true}
      description={
        <div>
          {t("warning.unit_remove", {
            unitName: unitName,
          })}
        </div>
      }
      renderActions={() => (
        <div className="">
          <Button
            color="red"
            onClick={() => {
              onSubmit();
            }}
          >
            {t("action.delete")}
          </Button>
          <Button
            color="green"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            {t("action.cancel")}
          </Button>
        </div>
      )}
    />
  );
}
const UnitsDeleteModalMutation = graphql`
  mutation UnitsDeleteModalMutation($id: ID!) {
    unitMeasureDelete(input: { id: $id }) {
      deleted
    }
  }
`;
